/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Managed_DeletedInputs */



/**
* | output |
* | --- |
* | "deleted in Discord" |
*
* @param {Leveling_Managed_DeletedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_managed_deleted = /** @type {((inputs?: Leveling_Managed_DeletedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Managed_DeletedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("удалена в Discord")
	return /** @type {LocalizedString} */ ("deleted in Discord")
});